import React, { useEffect, useState } from "react";
import logoimg from "../assets/logo.png";

const RegistrationThankYou = () => {
    return (
      <div className="new-register-pagewidth">
        <div className="new-register-logodiv">
          <img src={logoimg} />
        </div>
        <h4 className="mt-4" style={{textAlign: 'center'}}>Thank You!</h4>
        <p className="new-register-maintitle">
        One of our representative will get back to you.
        </p>
      </div>
    );
}

export default RegistrationThankYou